// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1bvy3","header":"ClearentDisclaimer_header__GX0xD","inner":"ClearentDisclaimer_inner__2RHEd"};